import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PERFORMANCESCORE,
  DELETE_PERFORMANCESCORE,
  UPDATE_PERFORMANCESCORE,
  ADD_NEW_PERFORMANCESCORE,
} from "./actionType";

import {
  getPerformanceScoreSuccess,
  getPerformanceScoreFail,
  deletePerformanceScoreSuccess,
  deletePerformanceScoreFail,
  updatePerformanceScoreSuccess,
  updatePerformanceScoreFail,
  addPerformanceScoreSuccess,
  addPerformanceScoreFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePerformanceScoreApi,
  getPerformanceScoreApi,
  updatePerformanceScoreApi,
  deletePerformanceScoreApi,
  addNewPerformanceScoreApi
} from "../../helpers/backend_helper";

function* getPerformanceScore({ payload: performanceScore }) {
  try {
    const response = yield call(getPerformanceScoreApi, performanceScore);
    yield put(getPerformanceScoreSuccess(GET_PERFORMANCESCORE, response.data));
  } catch (error) {
    yield put(getPerformanceScoreFail(GET_PERFORMANCESCORE, error));
  }
}

function* onUpdatePerformanceScore({ payload: performanceScore }) {
  try {
    if (performanceScore.setApprove) {
      const response = yield call(approvePerformanceScoreApi, performanceScore);
      yield put(updatePerformanceScoreSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePerformanceScoreApi, performanceScore);
      yield put(updatePerformanceScoreSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePerformanceScoreFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePerformanceScore({ payload: performanceScore }) {
  try {
    const response = yield call(deletePerformanceScoreApi, performanceScore);
    yield put(deletePerformanceScoreSuccess({ performanceScore, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePerformanceScoreFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPerformanceScore({ payload: performanceScore }) {
  try {
    const response = yield call(addNewPerformanceScoreApi, performanceScore);
    yield put(addPerformanceScoreSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPerformanceScoreFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPerformanceScore() {
  yield takeEvery(GET_PERFORMANCESCORE, getPerformanceScore);
}

export function* watchUpdatePerformanceScore() {
  yield takeEvery(UPDATE_PERFORMANCESCORE, onUpdatePerformanceScore);
}

export function* watchDeletePerformanceScore() {
  yield takeEvery(DELETE_PERFORMANCESCORE, onDeletePerformanceScore);
}

export function* watchAddNewPerformanceScore() {
  yield takeEvery(ADD_NEW_PERFORMANCESCORE, onAddNewPerformanceScore);
}

function* performanceScoreSaga() {
  yield all([
    fork(watchGetPerformanceScore),
    fork(watchDeletePerformanceScore),
    fork(watchUpdatePerformanceScore),
    fork(watchAddNewPerformanceScore)
  ]);
}

export default performanceScoreSaga;
